/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { resourcesList } from "../funcs/resourcesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListResourcesResult } from "../models/components/listresourcesresult.js";
import {
  ListResourcesRequest,
  ListResourcesSecurity,
} from "../models/operations/listresources.js";
import { unwrapAsync } from "../types/fp.js";
export type ListResourcesQueryData = ListResourcesResult;

export function prefetchListResources(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListResourcesRequest | undefined,
  security?: ListResourcesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListResourcesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListResourcesQuery(
  client$: GramCore,
  request?: ListResourcesRequest | undefined,
  security?: ListResourcesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListResourcesQueryData>;
} {
  return {
    queryKey: queryKeyListResources({
      cursor: request?.cursor,
      limit: request?.limit,
      deploymentId: request?.deploymentId,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listResourcesQueryFn(
      ctx,
    ): Promise<ListResourcesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(resourcesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListResources(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    deploymentId?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "resources", "list", parameters];
}
